@if (clusterDriverRoles) {
  <div class="flex flex-row flex-wrap gap-2" (click)="clusterDriverRoles = false">
    @if (driverRolesObj['DRIVER_TEAM_LEAD']) {
      <xyz-shared-tag-group class="tag-group">
        <xyz-shared-tag
          title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER_TEAM_LEAD' | translate }}"
          [square]="true"
          severity="normal"
          [small]="true">
          {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER_TEAM_LEAD' | translate }}
        </xyz-shared-tag>
        <xyz-shared-tag
          [square]="true"
          severity="normal"
          [small]="true"
          [outlined]="true"
          [noMinWidth]="true">
          {{ driverRolesObj['DRIVER_TEAM_LEAD'].length }}
        </xyz-shared-tag>
      </xyz-shared-tag-group>
    }
    @if (driverRolesObj['DRIVER']) {
      <xyz-shared-tag-group class="tag-group">
        <xyz-shared-tag
          title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER' | translate }}"
          [square]="true"
          severity="normal"
          [small]="true">
          {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER' | translate }}
        </xyz-shared-tag>
        <xyz-shared-tag
          [square]="true"
          severity="normal"
          [small]="true"
          [outlined]="true"
          [noMinWidth]="true">
          {{ driverRolesObj['DRIVER'].length }}
        </xyz-shared-tag>
      </xyz-shared-tag-group>
    }
    @if (driverRolesObj['DRIVER_TEAM_ASSISTANT']) {
      <xyz-shared-tag-group class="tag-group">
        <xyz-shared-tag
          title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER_TEAM_ASSISTANT' | translate }}"
          [square]="true"
          severity="normal"
          [small]="true">
          {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER_TEAM_ASSISTANT' | translate }}
        </xyz-shared-tag>
        <xyz-shared-tag
          [square]="true"
          severity="normal"
          [small]="true"
          [outlined]="true"
          [noMinWidth]="true">
          {{ driverRolesObj['DRIVER_TEAM_ASSISTANT'].length }}
        </xyz-shared-tag>
      </xyz-shared-tag-group>
    }
    @if (driverRolesObj['NO_ROLE']) {
      <xyz-shared-tag-group class="tag-group">
        <xyz-shared-tag
          title="{{ 'SHARED.DRIVER_ROLES.ROLES.NO_ROLE' | translate }}"
          [square]="true"
          severity="normal"
          [small]="true">
          {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.NO_ROLE' | translate }}
        </xyz-shared-tag>
        <xyz-shared-tag
          [square]="true"
          severity="normal"
          [small]="true"
          [outlined]="true"
          [noMinWidth]="true">
          {{ driverRolesObj['NO_ROLE'].length }}
        </xyz-shared-tag>
      </xyz-shared-tag-group>
    }
  </div>
} @else {
  <div (click)="clusterDriverRoles = true" class="flex flex-column gap-2">
    @if (driverRolesObj['DRIVER_TEAM_LEAD']) {
      <div class="flex flex-row gap-2 flex-wrap">
        @for (user of driverRolesObj['DRIVER_TEAM_LEAD']; track user.id) {
          <xyz-shared-tag-group class="tag-group">
            <xyz-shared-tag
              title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER_TEAM_LEAD' | translate }}"
              [square]="true"
              severity="normal"
              [small]="true">
              {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER_TEAM_LEAD' | translate }}
            </xyz-shared-tag>
            <xyz-shared-tag
              [square]="true"
              severity="normal"
              [small]="true"
              [outlined]="true"
              [noMinWidth]="true">
              {{ user.firstname }} {{ user.lastname }}
            </xyz-shared-tag>
          </xyz-shared-tag-group>
        }
      </div>
    }
    @if (driverRolesObj['DRIVER']) {
      <div class="flex flex-row gap-2 flex-wrap">
        @for (user of driverRolesObj['DRIVER']; track user.id) {
          <xyz-shared-tag-group class="tag-group">
            <xyz-shared-tag
              title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER' | translate }}"
              [square]="true"
              severity="normal"
              [small]="true">
              {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER' | translate }}
            </xyz-shared-tag>
            <xyz-shared-tag
              [square]="true"
              severity="normal"
              [small]="true"
              [outlined]="true"
              [noMinWidth]="true">
              {{ user.firstname }} {{ user.lastname }}
            </xyz-shared-tag>
          </xyz-shared-tag-group>
        }
      </div>
    }
    @if (driverRolesObj['DRIVER_TEAM_ASSISTANT']) {
      <div class="flex flex-row gap-2 flex-wrap">
        @for (user of driverRolesObj['DRIVER_TEAM_ASSISTANT']; track user.id) {
          <xyz-shared-tag-group class="tag-group">
            <xyz-shared-tag
              title="{{ 'SHARED.DRIVER_ROLES.ROLES.DRIVER_TEAM_ASSISTANT' | translate }}"
              [square]="true"
              severity="normal"
              [small]="true">
              {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.DRIVER_TEAM_ASSISTANT' | translate }}
            </xyz-shared-tag>
            <xyz-shared-tag
              [square]="true"
              severity="normal"
              [small]="true"
              [outlined]="true"
              [noMinWidth]="true">
              {{ user.firstname }} {{ user.lastname }}
            </xyz-shared-tag>
          </xyz-shared-tag-group>
        }
      </div>
    }
    @if (driverRolesObj['NO_ROLE']) {
      <div class="flex flex-row gap-2 flex-wrap">
        @for (user of driverRolesObj['NO_ROLE']; track user.id) {
          <xyz-shared-tag-group class="tag-group">
            <xyz-shared-tag
              title="{{ 'SHARED.DRIVER_ROLES.ROLES.NO_ROLE' | translate }}"
              [square]="true"
              severity="normal"
              [small]="true">
              {{ 'SHARED.DRIVER_ROLES.SHORT_ROLES.NO_ROLE' | translate }}
            </xyz-shared-tag>
            <xyz-shared-tag
              [square]="true"
              severity="normal"
              [small]="true"
              [outlined]="true"
              [noMinWidth]="true">
              {{ user.firstname }} {{ user.lastname }}
            </xyz-shared-tag>
          </xyz-shared-tag-group>
        }
      </div>
    }
  </div>
}
